import { defineComponent, ref, onMounted, onBeforeUnmount } from 'vue';
import VarButton from '../button';
import VarIcon from '../icon';
import { props } from './props';
import { isString, easeInOutCubic, throttle, isObject } from '../utils/shared';
import { getScrollTop, getScrollLeft, scrollTo, getParentScroller, toPxNum, toSizeUnit } from '../utils/elements';
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache) {
  var _component_var_icon = _resolveComponent("var-icon");

  var _component_var_button = _resolveComponent("var-button");

  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["var-back-top", [_ctx.show ? 'var-back-top--active' : null]]),
    ref: "backTopEl",
    style: _normalizeStyle({
      right: _ctx.toSizeUnit(_ctx.right),
      bottom: _ctx.toSizeUnit(_ctx.bottom)
    }),
    onClick: _cache[0] || (_cache[0] = _withModifiers(function () {
      return _ctx.click && _ctx.click(...arguments);
    }, ["stop"]))
  }, [_renderSlot(_ctx.$slots, "default", {}, () => [_createVNode(_component_var_button, {
    type: "primary",
    round: "",
    "var-back-top-cover": ""
  }, {
    default: _withCtx(() => [_createVNode(_component_var_icon, {
      name: "chevron-up"
    })]),
    _: 1
    /* STABLE */

  })])], 6
  /* CLASS, STYLE */
  );
}
export default defineComponent({
  render,
  name: 'VarBackTop',
  components: {
    VarButton,
    VarIcon
  },
  props,

  setup(props) {
    var show = ref(false);
    var backTopEl = ref(null);
    var target;

    var click = event => {
      props.onClick == null ? void 0 : props.onClick(event);
      var left = getScrollLeft(target);
      scrollTo(target, {
        left,
        duration: props.duration,
        animation: easeInOutCubic
      });
    };

    var scroll = () => {
      show.value = getScrollTop(target) >= toPxNum(props.visibilityHeight);
    };

    var throttleScroll = throttle(scroll, 200);

    var getTarget = () => {
      var {
        target
      } = props;

      if (isString(target)) {
        var el = document.querySelector(props.target);

        if (!el) {
          throw Error('[Varlet] BackTop: target element cannot found');
        }

        return el;
      }

      if (isObject(target)) {
        return target;
      }

      throw Error('[Varlet] BackTop: type of prop "target" should be a selector or an element object');
    };

    onMounted(() => {
      target = props.target ? getTarget() : getParentScroller(backTopEl.value);
      target.addEventListener('scroll', throttleScroll);
    });
    onBeforeUnmount(() => {
      target.removeEventListener('scroll', throttleScroll);
    });
    return {
      show,
      backTopEl,
      toSizeUnit,
      click
    };
  }

});